import { HoneycombProductType } from '../../constants/productTypes';
import { ProductBuilderMachineState } from '../../types';

type HoneycombStatesByProductType = {
  [key in HoneycombProductType]: ProductBuilderMachineState[];
};

export const allHoneycombStates: ProductBuilderMachineState[] = [
  'materialType',
  'colour',
  'colourNight',
  'dayColour',
  'dayFabricPosition',
  'cellDesign',
  'stackSide',
  'driveControl',
  'powerSupply',
  'remoteControl',
  'fitting',
  'measurements',
  // 'measureInsurance',
  'liftPosition',
  'extensionPole',
  'railColour',
  'lightGuards',
  // 'mountingSurface', Im leaving this in case it comes back later
  'roomName',
  // 'shipping',
  'complete',
];

const dayNightCorded = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'colour',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'extensionPole',
    'liftPosition',
    'lightGuards',
  ];
  return !blackList.includes(state);
});

const dayNightCordless = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'colour',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'liftPosition',
    'lightGuards',
  ];
  return !blackList.includes(state);
});

const dayNightMotorised = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'colour',
    'stackSide',
    'liftPosition',
    'extensionPole',
  ];
  return !blackList.includes(state);
});

const skylight = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'driveControl',
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'liftPosition',
    'lightGuards',
  ];
  return !blackList.includes(state);
});

const smartfit = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'driveControl',
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'liftPosition',
    'lightGuards',
  ];
  return !blackList.includes(state);
});

const smartfitDayNight = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'driveControl',
    'colour',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'liftPosition',
    'lightGuards',
  ];
  return !blackList.includes(state)
})

const dualViewCorded = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'extensionPole',
    'liftPosition',
  ];
  return !blackList.includes(state);
});

const dualViewCordless = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'liftPosition',
  ];
  return !blackList.includes(state);
});

const dualViewMotorised = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'extensionPole',
  ];
  return !blackList.includes(state);
});

const standardCorded = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'extensionPole',
  ];
  return !blackList.includes(state);
});

const standardCordless = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'liftPosition',
  ];
  return !blackList.includes(state);
});

const standardCordloop = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'powerSupply',
    'remoteControl',
    'extensionPole',
  ];
  return !blackList.includes(state);
});

const standardMotorised = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'stackSide',
    'extensionPole',
  ];
  return !blackList.includes(state);
});

const verticalDayNight = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'colour',
    'stackSide',
    'liftPosition',
    'powerSupply',
    'remoteControl',
    'lightGuards',
    'extensionPole',
  ];
  return !blackList.includes(state);
});

const vertical = allHoneycombStates.filter(state => {
  const blackList: ProductBuilderMachineState[] = [
    'driveControl',
    'dayColour',
    'colourNight',
    'dayFabricPosition',
    'powerSupply',
    'remoteControl',
    'liftPosition',
    'lightGuards',
    'extensionPole',
  ];
  return !blackList.includes(state);
});

// Skylight, Smartfit, Vertical and Vertical Day/Night are all variations of cordless
export const honeycombStatesByProductType: HoneycombStatesByProductType = {
  'Honeycomb Day/Night Corded': dayNightCorded,
  'Honeycomb Day/Night Cordless': dayNightCordless,
  'Honeycomb Day/Night Motorised': dayNightMotorised,
  'Honeycomb Skylight': skylight,
  'Honeycomb Smartfit': smartfit,
  'Honeycomb Smartfit Totalshade':smartfit,
  'Honeycomb SmartFit Day Night': smartfitDayNight,
  'Honeycomb Dual View Corded': dualViewCorded,
  'Honeycomb Dual View Cordless': dualViewCordless,
  'Honeycomb Dual View Motorised': dualViewMotorised,
  'Honeycomb Standard Corded': standardCorded,
  'Honeycomb Standard Cordless': standardCordless,
  'Honeycomb Standard Cordloop': standardCordloop,
  'Honeycomb Standard Motorised': standardMotorised,
  'Honeycomb Vertical Day/Night': verticalDayNight,
  'Honeycomb Vertical': vertical,
};
